import React from 'react';
import { Session } from '../types';
import './SessionTable.css';

interface SessionTableProps {
  sessions: Session[];
  onSessionClick: (sessionId: string) => void;
  selectedSessionId: string | null;
}

export const SessionTable: React.FC<SessionTableProps> = ({
  sessions,
  onSessionClick,
  selectedSessionId
}) => {
  const formatTime = (timestamp: string) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return `${seconds}s ago`;
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'normal':
        return '✓';
      case 'suspicious':
        return '⚠';
      case 'trapped':
        return '🎯';
      default:
        return '•';
    }
  };

  return (
    <div className="session-table-container">
      <table className="session-table">
        <thead>
          <tr>
            <th>Session ID</th>
            <th>IP Address</th>
            <th>Status</th>
            <th>Trap Type</th>
            <th>Events</th>
            <th>Last Activity</th>
          </tr>
        </thead>
        <tbody>
          {sessions.length === 0 ? (
            <tr>
              <td colSpan={6} className="no-sessions">
                No active sessions
              </td>
            </tr>
          ) : (
            sessions.map((session) => (
              <tr
                key={session.sessionId}
                onClick={() => onSessionClick(session.sessionId)}
                className={`session-row ${
                  selectedSessionId === session.sessionId ? 'session-row--selected' : ''
                } session-row--${session.status.toLowerCase()}`}
              >
                <td className="session-id">
                  <span className="session-icon">{getStatusIcon(session.status)}</span>
                  {session.sessionId}
                </td>
                <td className="session-ip">{session.sourceIp}</td>
                <td>
                  <span className={`status-badge status--${session.status.toLowerCase()}`}>
                    {session.status}
                  </span>
                </td>
                <td>
                  {session.trapType && (
                    <span className="trap-badge">{session.trapType}</span>
                  )}
                </td>
                <td className="session-events">
                  <span className="event-count">{session.eventCount}</span>
                </td>
                <td className="session-time">{formatTime(session.lastActivity)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
